<!-- 切换科目 -->
<template>
<van-popup v-model="show" class="change-subject-popup list-popup" position="right">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">切换科目</div>
    </div>
    <div class="change-subject-content" v-if="show">
        <div class="tabs-box">
            <div class="tab-item" @click="handleChangeCurrentTree(index)" :class="{active: currentTreeIndex === index}" v-for="(item, index) in subjectTree" :key="item.code">{{item.name}}</div>
        </div>
        <div class="subject-list">
            <div class="subject-item" :class="{active: currentSubjectCode === item.code}" @click="handleChangeSubject(item)" v-for="(item) in subjectTree[currentTreeIndex].subjects" :key="item.code">{{item.name}}</div>
        </div>
    </div>
</van-popup>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
export default {
    data() {
        return {
            show: false,
            subjectTree: [],
            currentTreeIndex: 0,
            currentSubjectCode: ''
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(examcode, subjectcode) {
            this.subjectTree = specialTopic.subjectTree[examcode]
            this.currentSubjectCode = subjectcode
            let flag = false
            this.subjectTree.some((item, index) => {
                item.subjects.some(option => {
                    if (option.code === subjectcode) {
                        this.currentTreeIndex = index
                        flag = true
                        return true
                    }
                })
                if (flag) {
                    return true
                }
            })
            this.show = true
        },
        handleClose() {
            this.show = false
        },
        handleChangeCurrentTree(index) {
            if (index !== this.currentTreeIndex) {
                this.currentTreeIndex = index
            }
        },
        handleChangeSubject(subjectitem) {
            if (this.currentSubjectCode !== subjectitem.code) {
                this.currentSubjectCode = subjectitem.code
                this.$emit('handleSubjectChange', this.currentSubjectCode)
                this.handleClose()
            }
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.change-subject-popup {
    width: 100vw;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .subject-item-box {
        height: 0.8rem;
        .el-scrollbar__view {
            display: flex;
            height: 0.8rem;
            .subject-item {
                padding: 0 0.35rem;
                line-height: 0.8rem;
                font-size: 0.3rem;
                color: #333333;
                white-space: nowrap;
                background: #fff;
                &.active {
                    color: #1D60AD;
                    background: rgba(29,96,173,0.1);
                    font-weight: bold;
                }
            }
        }
    }
    .subject-box {
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.28rem;
        box-sizing: border-box;
        background: #fff;
        .subject-name {
            font-size: 0.3rem;
            color: #333333;
            font-weight: bold;
        }
        .handle {
            display: flex;
            align-items: center;
            .handle-icon {
                width: 0.28rem;
                height: 0.28rem;
                margin-right: 0.08rem;
            }
            .handle-label {
                font-size: 0.26rem;
                color: #666666;
            }
        }
    }
    .change-subject-content {
		height: calc(100% - 0.88rem);
		display: flex;
		.tabs-box {
			height: 100%;
			box-sizing: border-box;
			background: #F8F8F8;
			width: 2.8rem;
			.tab-item {
				height: 1rem;
				line-height: 1rem;
				text-align: center;
				font-size: 0.28rem;
				color: #333333;
				&.active {
					background: #E1EBF6;
					color: #1D60AD;
				}
			}
		}
		.subject-list {
			width: 4.7rem;
			background: #FFFFFF;
            padding: 0;
			.subject-item {
				height: 1rem;
				padding: 0 0.28rem;
				box-sizing: border-box;
				font-size: 0.28rem;
				color: #333333;
				display: flex;
				align-items: center;
				line-height: 0.4rem;
                border-bottom: none !important;
				&.active {
					color: #1D60AD;
				}
			}
		}
	}
}
</style>